import BoardListContainer from './BoardListContainer'
import BoardList from './BoardList'
export default BoardListContainer(BoardList)